export default __webpack_public_path__ + "static/media/lgo.17f13b2c.png";